<template>
    <div class="publicidades" v-if="list.length > 0">

        <a v-if="type==1" v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
            <!-- paralax -->
            <section class="spacing-tb parallax"
                     :style="{
                     backgroundImage: 'url( ' + item.file + ' )'
                     }">
            </section>
            <!-- paralax -->
        </a>

        <div v-if="type==2 && list.length > 0" class="fixed-footer">
            <div class="container">
                <div class="g g-1180">
                    <div class="close f-right" @click="closeFixed">Fechar <i class="fas fa-window-close"></i></div>
                    <a v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
                        <img :src="item.file" :alt="item.title">
                    </a>
                </div>
            </div>
        </div>


        <div v-if="type==3 && list.length > 0" class="popup" @click="closePopUp">
            <div class="img-container">
                    <div class="close f-right" @click="closePopUp">Fechar <i class="fas fa-window-close"></i></div>
                    <a v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
                        <img :src="item.file" :alt="item.title">
                    </a>
            </div>
        </div>



        <section  v-if="type==4 && list.length > 0" class="banner-box cycle-slideshow"
            data-cycle-center-horz=true
            data-cycle-center-vert=true
            data-cycle-timeout=4000
            data-cycle-slides="a">
            <a v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
                <img :src="item.file" :alt="item.title">
            </a>
        </section>

        <section v-if="type==5 && list.length > 0" class="fixed-banner fixed-footer">
            <span class="close-fixed-banner" @click="closeFixed"><i class="fas fa-window-close"></i></span>
            <div class="cycle-slideshow"
                data-cycle-timeout=4000
                data-cycle-slides="a"
                >
                <a v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
                    <img :src="item.file" :alt="item.title">
                </a>
            </div>
        </section>

        <a v-if="type==0" v-for="(item, index) in list" :title="item.title" :href="item.url" :target="item.target">
            <img :src="item.file" :alt="item.title">
        </a>

        <span v-if="showBadge" class="badge">Publicidades</span>


    </div>
</template>

<script>
    export default {
        name: "Publicidades",
        props: {
            'category': {
                default: 0
            },
            'type': {
                default: 0 // 0: Publicidades normais; 1: Paralax; 2: Footer site; 3: Pop-up
            },
            'limit': {
                default: 0
            },
            'random' : {
                type: Boolean,
                default: false
            },
            'timer' : {
                type: Number,
                default: 0,
            },
            'show-badge' : {
                type: Boolean,
                default: false
            },
        },

        data: function(){
            return{
                list: [],
                current_page: 1,
                total_pages: 0,
            }
        },

        created: function(){
            this.showPublicidades();
        },
        watch:{
            '$root.$data.publicidades': 'showPublicidades'
        },
        methods: {
            showPublicidades(){

                let lista = this.$root.$data.publicidades.filter( ( item ) => {
                    return item.id == this.category;
                });

                let temp_list = [];

                if( lista.length > 0 )
                    temp_list = lista[ 0 ].publicidades_actived;


                if( this.random == true )
                    temp_list = temp_list.sort(() => .5 - Math.random());

                if( this.limit > 0 &&  this.limit < temp_list.length )
                    temp_list = temp_list.slice( (this.current_page - 1) * this.limit, this.current_page * this.limit );


                this.list = temp_list;

                if( this.type == 4 || this.type == 5 ){

                    this.$nextTick(function () {
                        $('.cycle-slideshow').cycle();
                    });
                }


                if( this.timer > 0 && this.limit > 0 && lista.length > 0 ){
                    this.total_pages = Math.ceil( lista[ 0 ].publicidades_actived.length / this.limit );

                    let self = this;

                    this.$nextTick(function () {
                        if(self.total_pages > 1){
                            setTimeout( function(){
                                self.current_page++;
                                if( self.current_page > self.total_pages ){
                                    self.current_page = 1;
                                }

                                self.$nextTick(function () {
                                    self.showPublicidades();
                                })
                            }, self.timer * 1000 );
                        }
                    });
                }


            },

            closeFixed()
            {
                $( '.fixed-footer' ).slideUp( 'fast' );
            },

            closePopUp()
            {
                $( '.popup' ).fadeOut( 'fast' );
            },
        },
    }
</script>



// WEBPACK FOOTER //
// vue/front/Publicidades.vue